<template>
    <div class="container">
        <!-- 顶部警告通知 - 永远在最顶部 -->
        <marquee v-if="isShowWarning" class="top-notice">
            平台将于今晚（2026年5月9日）23:00 进行数据库升级维护，期间平台会出现短暂无法访问的情况，预计持续数分钟。建议您提前保存相关内容并做好安排。给您带来的不便，我们深表歉意，感谢您的理解与支持！
        </marquee>

        <nav class="navbar-container">
            <div class="navbar">
                <h1 class="navbar-logo">
                    <img alt="logo" src="@/assets/img/homes/logo.png" class="navbar-logo--img"/>
                    维普培训考试服务平台
                </h1>
                <router-link to="/home-exam" active-class="is--active" class="navbar-item">
                    考试平台
                </router-link>
                <router-link to="/home-business" active-class="is--active" class="navbar-item">
                    行业方案
                </router-link>
                <router-link to="/home-organization" active-class="is--active" class="navbar-item">
                    机构定制
                </router-link>
                <div class="login-container" v-if="isShowLoginBtn">
                    <span class="pointer" @click.stop="handleLogin">登录</span>
                    <span class="divide">|</span>
                    <span class="pointer" @click.stop="handleLogin">注册</span>
                </div>
            </div>
        </nav>
        <login-diolog :show.sync="loginDialogShow"/>
    </div>
</template>

<script>
import { HOME_PAGE_MAP } from "@/utils/platform-config";
import { showWarningBar } from "../../../utils/maintainTime";
export default {
    name: "NavBar",
    computed: {
        // 是否显示登录按钮
        isShowLoginBtn () {
            const path = this.$route.path
            return ["/home-exam"].includes(path) && HOME_PAGE_MAP[this.$store.state.platform].path === path
        },
        // 警告条显示条件：指定页面 + 时间范围内
        isShowWarning() {
            return ['/home-medicine','/home-exam'].includes(this.$route.path) && showWarningBar()
        }
    },
    data() {
        return {
            loginDialogShow: false
        }
    },
    created() {
        this.$bus.$on("pc-login-success", this.handleLoginSuccess)
    },
    methods: {
        handleLogin () {
            this.loginDialogShow = true
        },
        handleLoginSuccess () {
            this.$router.replace("/")
        }
    },
    beforeDestroy() {
        this.$bus.$off("pc-login-success", this.handleLoginSuccess)
    }
}
</script>

<style scoped lang="less">
/* 顶部通知 - 固定最顶部 */
.top-notice {
    display: block;
    width: 100%;
    background: #fff7e8;
    color: #f57c00;
    font-size: 16px;
    line-height: 1.4;
    padding: 5px 20px;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
}

.navbar-container {
    height: 70px;
    box-sizing: border-box;
    position: relative;
    z-index: 9;
}

/* 导航栏：根据警告条是否显示，自动调整位置 */
.navbar {
    height: 70px;
    position: fixed;
    /* 关键：警告显示时往下，不显示时贴顶 */
    top: calc(var(--notice-height, 0px));
    left: 0;
    right: 0;
    box-sizing: border-box;
    padding-left: 100px;
    padding-right: 190px;
    background-color: #fff;
    display: flex;
    align-items: center;

    &-logo {
        font-size: 26px;

        &--img {
            width: 70px;
            height: 35px;
            vertical-align: middle;
            margin-right: 10px;
        }

        & h1 {
            margin: 0;
            padding: 0;
        }
    }
}

/* 警告显示时，给导航设置动态 top */
.container:has(.top-notice) .navbar {
    top: 32px;
}

.navbar-item {
    font-size: 16px;
    margin-left: 40px;
    position: relative;
    transition: .2s;

    &.is--active {
        color: #D43422;
        font-weight: 600;

        &::after {
            content: "";
            position: absolute;
            bottom: -14px;
            left: 0;
            right: 0;
            height: 5px;
            background-color: #D43422;
            margin-top: 10px;
        }
    }
}

.login-container {
    margin-left: auto;
    font-size: 16px;

    .divide {
        margin: 0 10px;
    }
}
</style>
